/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, minLength, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusChangePasswordDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusChangePasswordDtoInitialValue(): LexplusChangePasswordDto {
  return {
  currentPassword: '',
  newPassword: '',
} as LexplusChangePasswordDto;
}

/**
 * Reusable Signal Forms schema for LexplusChangePasswordDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusChangePasswordDtoSchema(path: SchemaPathTree<LexplusChangePasswordDto>): void {
  required(path.currentPassword);
  minLength(path.currentPassword, 1);
  required(path.newPassword);
  minLength(path.newPassword, 1);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusChangePasswordDtoForm(initial?: Partial<LexplusChangePasswordDto>) {
  const model: WritableSignal<LexplusChangePasswordDto> = signal<LexplusChangePasswordDto>({
    ...getLexplusChangePasswordDtoInitialValue(),
    ...initial,
  } as LexplusChangePasswordDto);
  return { model, field: form(model, lexplusChangePasswordDtoSchema) };
}
